import { defineComponent, PropType } from 'vue';

export default defineComponent({
	props: {
		id: {
			type: Number as PropType<number>,
			required: true
		},
		question: {
			type: String as PropType<string>,
			required: true
		},
		answer: {
			type: String as PropType<string>,
			required: true
		},
		active: {
			type: Boolean as PropType<boolean>,
			required: true
		},
		
	},
	setup: (props: any) => {

		return {
			props
		};
	},
});
